import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { Alert, AlertParameter, OcurrenceId } from '../../models/alert/alert';
import { AlertType } from '../../models/alert/alert-type';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { GetEnterpriseAlert } from 'src/app/models/enterprise-alert/getEnterpriseAlert';
import { GetCameraAlerts } from 'src/app/models/camera/getCameraAlerts';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EnterpriseAlertService {

  constructor(
    private httpClient: HttpClient
  ) { }

  private POST_ENDPOINT: string = 'Alert';
  private BASE_URL: string = `${environment.sistemaWebAdmin}`;
  private REQUEST_URL: string = `${this.BASE_URL}/${this.POST_ENDPOINT}`;

  getTypesOrCategoriesByEnterprise(id): Observable<GetEnterpriseAlert> {
    return this.httpClient.get<GetEnterpriseAlert>(`${this.REQUEST_URL}/types-categories/${id}`);
  }

  GetListAlertPanel(data : any): Observable<GetCameraAlerts> {
    const params = new HttpParams({ fromObject: data });
    return this.httpClient.get<GetCameraAlerts>(`${this.REQUEST_URL}/list-alert-panel`, { params });
  }

  GetReportAlertPanel(data : any): Observable<GetCameraAlerts> {
    const params = new HttpParams({ fromObject: data });
    return this.httpClient.get<GetCameraAlerts>(`${this.REQUEST_URL}/report-alert-panel`, { params });
  }

  GetReportAlertPanelExport(payload: any): Observable<Blob> {
    const params = new HttpParams({ fromObject: payload });
    return this.httpClient.get<Blob>(`${this.REQUEST_URL}/report-alert-panel-excel`, {
      params,
      responseType: 'blob' as 'json'
    })
      .pipe(catchError(this.parseErrorBlob))
  }

  parseErrorBlob(err: HttpErrorResponse): Observable<any> {
    const reader: FileReader = new FileReader();

    const obs = Observable.create((observer: any) => {
      reader.onloadend = (e) => {
        observer.error(JSON.parse(reader.result.toString()));
        observer.complete();
      }
    });
    reader.readAsText(err.error);
    return obs;
  }

}
